<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="bg-white marginTop relative">
        <span
          @click="redirectCrm"
          class="cursor-pointer absolute top-1 left-1 z-20 flex uppercase font-bold sm:bg-gray-100 px-3 rounded-lg"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-red-500 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
              clip-rule="evenodd"
            />
          </svg>
          CRM
        </span>

        <!-- stats dashboard -->
        <dashboardstats
          :receipts="true"
          :totalDelivered="totalDelivered"
          :totalFailed="totalFailed"
          :totalOpened="totalOpened"
          :messages="filterEmail"
        ></dashboardstats>

        <div
          class="max-w-2xl mx-auto py-24 px-4 grid items-center grid-cols-1 gap-y-16 gap-x-8 sm:px-6 sm:py-12 lg:max-w-7xl lg:px-8 lg:grid-cols-1"
        >
          <div>
            <h2
              class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl"
            >
              Receipts Overview
            </h2>

            <!-- <p class="mt-4 text-gray-500">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to </p> -->

            <dl
              class="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-10 sm:gap-y-16 lg:gap-x-8"
            >
              <div
                v-for="message in filterEmail"
                :key="message.id"
                class="bg-gray-50 border-t border-gray-200 py-4"
              >
                <dt
                  class="px-2 font-medium text-lg uppercase text-gray-900 sm:flex sm:align-center"
                >
                  {{ message.message_name }}

                  <template v-if="message.repeating_message == 1">
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                    >
                      Repeated Message
                    </span>
                  </template>
                  <template v-else>
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800"
                    >
                      Single Deliver
                    </span>
                  </template>

                  <span
                    v-if="message.deliver_date"
                    @click="openRecipients(message)"
                    class="ml-2 cursor-pointer inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                  >
                    Check Status
                  </span>

                  <span
                    v-else
                    @click="redirect(message)"
                    class="cursor-pointer inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
                  >
                    Assign Deliver Date
                  </span>

                  <a
                    @click="redirect(message)"
                    class="ml-2 text-indigo-600 hover:text-indigo-900"
                  >
                    <svg
                      class="h-6 w-6 text-green-500"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <path
                        d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
                      />
                      <path
                        d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
                      />
                      <line x1="16" y1="5" x2="19" y2="8" />
                    </svg>
                  </a>
                </dt>

                <dt class="px-2 my-2 text-gray-800 font-light">
                  <v-expansion-panels multiple :value="[0]">
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <span class="uppercase">Display Receipt</span>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <dl
                          class="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-4"
                        >
                          <div
                            class="flex flex-col border-b border-gray-100 p-4 text-center sm:border-0 sm:border-r"
                          >
                            <dt
                              class="order-2 mt-2 text-lg leading-6 font-light text-gray-500"
                            >
                              Delivered
                            </dt>
                            <dd
                              class="order-1 text-3xl font-extrabold text-indigo-600"
                            >
                              {{ message.statusMessage.delivered.total }}
                            </dd>
                          </div>
                          <div
                            class="flex flex-col border-t border-b border-gray-100 p-4 text-center sm:border-0 sm:border-l sm:border-r"
                          >
                            <dt
                              class="order-2 mt-2 text-lg leading-6 font-light text-gray-500"
                            >
                              Opened
                            </dt>
                            <dd
                              class="order-1 text-3xl font-bold text-indigo-600"
                            >
                              {{ message.statusMessage.opened.unique }}
                            </dd>
                          </div>

                          <div
                            class="flex flex-col border-r border-gray-100 p-4 text-center sm:border-0 sm:border-l"
                          >
                            <dt
                              class="order-2 mt-2 text-lg leading-6 font-light text-gray-500"
                            >
                              Clicked
                            </dt>
                            <dd
                              class="order-1 text-3xl font-bold text-orange-500"
                            >
                              {{ message.statusMessage.clicked.unique }}
                            </dd>
                          </div>

                          <div
                            class="flex flex-col border-t border-gray-100 p-4 text-center sm:border-0 sm:border-l"
                          >
                            <dt
                              class="order-2 mt-2 text-lg leading-6 font-light text-gray-500"
                            >
                              Failed
                            </dt>
                            <dd class="order-1 text-3xl font-bold text-red-600">
                              {{ message.statusMessage.failed.permanent.total }}
                            </dd>
                          </div>
                        </dl>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <span class="uppercase"
                          >Tags Assigned</span
                        ></v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <!-- v-if="message.tags.length > 0"  -->
                        <div class="rounded-lg bg-white shadow-lg p-2">
                          <div v-for="crmTag in message.tags" :key="crmTag.id">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-1 inline-flex rounded-full items-center py-1 px-2.5 text-sm font-medium bg-gray-700 text-gray-50"
                                >
                                  {{ crmTag.name }}
                                </span>
                              </template>
                              <span v-if="crmTag.users.length > 0">
                                <div
                                  v-for="tagUser in crmTag.users"
                                  :key="tagUser.id"
                                >
                                  {{ tagUser.name }}
                                </div>
                              </span>
                              <span v-else>
                                Empty
                              </span>
                            </v-tooltip>
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </dt>
              </div>
            </dl>
          </div>
        </div>
      </div>

      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpen">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="md:text-left h-full w-full inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-headline"
              >
                Recipients in ( {{ selected.message_name }} )
              </h3>

              <div class="relative my-2">
                <div class="absolute top-4 left-3">
                  <i
                    class="fa fa-search text-gray-400 z-20 hover:text-gray-500"
                  ></i>
                </div>
                <form>
                  <input
                    type="search"
                    v-model="searchUser"
                    class="bg-white text-gray-700 h-14 w-full pl-10 pr-20 rounded-lg border z-0 focus:shadow focus:outline-none"
                    placeholder="Search user..."
                  />
                  <div class="absolute top-2 right-2"></div>
                </form>
              </div>

              <table
                class="min-w-full divide-y divide-gray-200 shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
              >
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Recipient
                    </th>

                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Status
                    </th>

                    <!-- <th
                              scope="col"
                              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Most Recent Activity
                            </th> -->
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="user in filterUsers" :key="user.id">
                    <td class="px-6 py-4 whitespace-nowrap">
                      <div class="text-sm text-gray-500">
                        {{ user.recipient }}
                      </div>
                    </td>

                    <td class="px-6 py-4">
                      <!-- : {{ getDeliver(user.statuses).length }} -->
                      <div v-if="getDeliver(user.statuses).length > 0">
                        <span
                          class="mt-1 px-2 text-xs leading-5 font-light rounded-full bg-green-100 text-green-800"
                        >
                          Delivered
                        </span>
                      </div>

                      <!-- {{ getFailed(user.statuses).length }} -->
                      <div v-else-if="getFailed(user.statuses).length > 0">
                        <span
                          class="mt-1 ml-2 px-2 text-xs leading-5 font-light rounded-full bg-red-100 text-red-800"
                        >
                          Failed
                        </span>
                      </div>
                    </td>

                    <!-- <td
                              class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-500"
                            >
                              {{ formatDate(user.date.date) }}
                            </td> -->
                  </tr>

                  <!-- More items... -->
                </tbody>
              </table>
            </div>

            <div
              class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
            >
              <button
                @click="closeModal()"
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dashboardstats from "./crm/dashboardStats.vue";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  components: { Dashboardstats },
  data() {
    return {
      search: "",
      messages: [],
      responseMessage: "",

      selected: "",
      isOpen: false,
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc",

      tags: "",
      showLoading: true,
      stats: "",
      selectedId: "",
      searchUser: ""
    };
  },

  computed: {
    filterUsers() {
      if (this.selected == "") {
        return;
      } else {
        return this.selected.mailgun.filter(item => {
          return item.recipient
            .toLowerCase()
            .includes(this.searchUser.toLowerCase());
        });
      }
    },

    filterEmail() {
      return this.messages.filter(item => {
        if (item.mailgun.length > 0) {
          return item.message_type == 0;
        } else {
          return false;
        }
      });
    },

    totalDelivered() {
      let sumArray = [];
      this.messages.filter(item => {
        if (item.mailgun.length > 0) {
          if (item.message_type == 0) {
            sumArray.push(item.statusMessage.delivered.total);
          } else {
            return false;
          }
        } else {
          return false;
        }
      });

      return sumArray.reduce((a, b) => a + b, 0);
    },

    totalFailed() {
      let sumArray = [];
      this.messages.filter(item => {
        if (item.mailgun.length > 0) {
          if (item.message_type == 0) {
            sumArray.push(item.statusMessage.failed.permanent.total);
          } else {
            return false;
          }
        } else {
          return false;
        }
      });

      return sumArray.reduce((a, b) => a + b, 0);
    },

    totalOpened() {
      let sumArray = [];
      this.messages.filter(item => {
        if (item.mailgun.length > 0) {
          if (item.message_type == 0) {
            sumArray.push(item.statusMessage.opened.unique);
          } else {
            return false;
          }
        } else {
          return false;
        }
      });

      return sumArray.reduce((a, b) => a + b, 0);
    }
  },

  created() {
    this.getMessages();
  },

  methods: {
    // getMessageStatus(message) {
    //   this.selectedId = message.id;
    //   window.axios.get("/api/getMessageStatus/" + message.id).then(response => {
    //     console.log(response.data);
    //     this.isOpen = true;
    //     this.stats = response.data;
    //   });
    // },

    redirectCrm() {
      this.$router.push({ name: "CRM" });
    },

    getDeliver(types) {
      return types.filter(type => {
        return type.toLowerCase().includes("delivered");
      });
    },

    getFailed(types) {
      return types.filter(type => {
        return type.toLowerCase().includes("failed");
      });
    },

    formatDate(date) {
      return moment(date).format("lll");
    },

    redirect(message) {
      this.$router.push({ name: "CrmMessage", params: { id: message.id } });
    },

    searching() {
      let query = this.search;
      window.axios.post("/api/resultMessage?q=" + query).then(res => {
        this.messages = res.data;
      });
    },

    sendResponse(message) {
      window.axios
        .post("/api/responseMessage", {
          responseMessage: this.responseMessage,
          messengerEmail: message.email
        })
        .then(() => {
          this.getMessages();
        });
    },

    getMessages() {
      window.axios.get("/api/message_index").then(response => {
        this.messages = response.data;
        this.showLoading = false;
      });
    },

    openRecipients(item) {
      this.selectedId = item.id;
      this.selected = item;
      // this.stats = '';
      this.isOpen = true;
      this.selectedId = "";
    },

    closeModal() {
      this.isOpen = false;
      this.selected = "";
      // this.stats = '';
      this.selectedId = "";
    },

    remove(item) {
      alert("Are you sure");
      window.axios.delete("/api/messages/" + item.id).then(() => {
        this.getMessages();
      });
    },

    client(message) {
      window.axios
        .post("/api/createClient", {
          user: message
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "User successfully created",
            text:
              "Hi, Jane here i sent an email to the new user to verify his account"
          });
        });
    }

    // removeTag(tag, message) {
    //   window.axios
    //     .post("/api/removeMessageTag", {
    //       messageId: message.id,
    //       tagId: tag.id
    //     })
    //     .then(() => {
    //       Swal.fire({
    //         position: "top-end",
    //         icon: "success",
    //         title: "Tag succesfully removed",
    //         showConfirmButton: false,
    //         timer: 1500
    //       });

    //       this.$router.push({ name: "CrmMessage", params: { id: message.id } });
    //     });
    // }
  }
};
</script>
<style lang="scss">
.loader {
  border-top-color: #3498db;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
